<template>
  <div class="concept">
    <div id="head-page" class="illuConcept parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/head/globulo-concept.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.4"><img class="" src="@/assets/images/head/icons-concept.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/coline-concept.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

   <div class="grid-container content-page">
      <div class="grid-x grid-container-padding">
        <div class="small-12 medium-8 medium-offset-2 large-6 large-offset-3 cell">

          <title-page attrpage="Concept" baseline="CONCEPT & OBJECTIFS DU PROGRAMME">Globulo Quest</title-page>

          <div class="box-mascotte">
            <div class="bubble bottom txtleft">
              <carousel :perPage="1" paginationActiveColor="#de2128" navigationEnabled="true" paginationColor="#ccc" :paginationSize="15">
                <slide>
                  <p>Bonjour, je suis <strong>Globulo</strong> !</p>
                  <p>Je suis ton compagnon et ton guide dans l’utilisation de cette plateforme.</p>
                </slide>
                <slide>
                  <p>La solution digitale <strong>Globulo Quest</strong> a pour but de t’accompagner dans ton parcours de soin, c’est-à-dire t’expliquer comment on va te soigner et qui va s’occuper de toi. 
                  </br>Comme ça, tu seras toujours accompagné, à l’hôpital ou à la maison.</p>
                </slide>
                <slide>
                  <p>Avant chaque rendez-vous important pour te soigner, un <strong>Mini-Jeu</strong> explicatif te sera proposé pour bien t’y préparer. </p>
                  <img src="@/assets/images/content/concept-jeu.jpg" alt="concept-jeu" title="concept-jeu"/>
                </slide>
                <slide>
                  <p>D’autres informations sous forme de <strong>documents</strong> ou <strong>vidéos</strong> par exemple te seront parfois proposées pour que tu comprennes bien.</p>
                  <img src="@/assets/images/content/concept-bibliotheque.jpg" alt="concept-bibliotheque" title="concept-bibliotheque"/>
                </slide>
                <slide>
                  <p>N’hésite pas à poser des questions ensuite à ta <strong>Globulo Team de soignants</strong> ou tes parents.
                  Ils ont accès à <strong>une bibliothèque</strong> en ligne avec pleins d’informations pour t’apporter des réponses. </p>
                  <img src="@/assets/images/content/concept-team.jpg" alt="concept-team" title="concept-team"/>
                </slide>
                <slide>
                  <p>À tout moment, tu auras aussi la possibilité de jouer au <strong>Jeu Fil Rouge</strong><em>(prochainement disponible) </em> avec ta <strong>communauté</strong> d’amis et ta famille. </p>
                  <p>Alors <strong>demande à tes parents de te créer un compte</strong> dès maintenant ainsi qu’à tes proches, connecte-toi et défie-les ! </p>
                </slide>
                <slide>
                  <p>Je suis aussi là pour te donner des conseils et que tu me dises comment tu te sens.</p>
                  <p>A très vite !</br><em>Globulo</em></p>
                </slide>
              </carousel>
            </div>
            <img class="img_mascotte" src="@/assets/images/mascotte/mascotte-red.png" alt="Globulo Quest mascotte" title="Globulo Quest mascotte"/>
          </div>



        </div>

        <div class="small-12 medium-12 cell center">
          <img class="concept" src="@/assets/images/content/Schema_GlobuloQuest.jpg" alt="Concept Globulo Quest" title="Concept Globulo Quest"/>
          <a class="button btnPush" href="../assets/Schema_GlobuloQuest.pdf" target="blank">Télécharger le schéma</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import TitlePage from '@/components/TitlePage'
  import { Carousel, Slide } from 'vue-carousel'
  export default {
    components: { TitlePage, Carousel, Slide },
  }
</script>
